import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import DeleteOutlineTwoToneIcon from "@mui/icons-material/DeleteOutlineTwoTone";
import AddCustomerForm from "./AddCustomerForm";
import translations from '../translations/customersTranslation';
import { isTestEnv } from "../globals";

const Customer = ({ setMockDropdownData, setSnackbar, mockDropdownData, execute }) => {
  const [customers, setCustomers] = useState([]);
  console.log(220);

  useEffect(() => {
    const getData = async () => {
      try {
        const customersResponse = await execute(
          "POST",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/customers/allCustomers`
        );        
        setCustomers(customersResponse);
      } catch (err) {
        isTestEnv && console.error(err);
      }
    };
    getData();
  }, []);

  const handleDeleteCustomer = async (id) => {
    const isSure = window.confirm(translations.areYouSureDeleteCustomer);
    if (isSure) {
      try {
        await execute(
          "DELETE",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/customers/deleteCustomer/${id}`
        );
        setCustomers(customers.filter((c) => c._id !== id));
        setMockDropdownData((prev) => ({
          ...prev,
          receiveCustomer: mockDropdownData.receiveCustomer.filter((c) => c._id !== id),
        }));
        setMockDropdownData((prev) => ({
          ...prev,
          ordererCustomer: mockDropdownData.ordererCustomer.filter((c) => c._id !== id),
        }));
        setSnackbar({ open: true, message: translations.customerDeletedSuccess, severity: "success" });
      } catch (error) {
        isTestEnv && console.error(error);
        setSnackbar({ open: true, message: translations.errorOccurred, severity: "error" });
      }
    }
  };

  return (
    <div>
      <Box mt={2}>
        <Typography variant="subtitle1">{translations.customers}</Typography>
        <div style={{ marginBottom: "20px" }}>
          <AddCustomerForm
            setCustomers={setCustomers}
            customers={customers}
            setMockDropdownData={setMockDropdownData}
          />
        </div>
        <TableContainer component={Paper}>
          <Table aria-label="receiving customers table">
            <TableHead>
              <TableRow>
                <TableCell>{translations.name}</TableCell>
                <TableCell>{translations.customerCode}</TableCell>
                <TableCell>{translations.customerType}</TableCell>
                <TableCell>{translations.orderingCustomer}</TableCell>
                <TableCell>{translations.receivingCustomer}</TableCell>
                <TableCell> </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((rc) => (
                <TableRow key={rc._id}>
                  <TableCell>{rc.custdes}</TableCell>
                  <TableCell>{rc.custname}</TableCell>
                  <TableCell>{rc.customerType}</TableCell>
                  <TableCell>{rc.orderingCustomer ? translations.yes : translations.no}</TableCell>
                  <TableCell>{rc.recivingCustomer ? translations.yes : translations.no}</TableCell>
                  <TableCell>
                    <Tooltip title={translations.deleteCustomer}>
                      <IconButton
                        color="warning"
                        aria-label="delete product family"
                        onClick={() => handleDeleteCustomer(rc._id)}
                      >
                        <DeleteOutlineTwoToneIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
};

export default Customer;
